import { apiFetch } from "@/lib/api-client";

interface FeedbackSignalInput {
  signalType: string;
  aiOutputId?: string;
  aiOutput: Record<string, unknown>;
  humanAction: Record<string, unknown>;
  context?: Record<string, unknown>;
}

export async function sendAiFeedbackSignal(input: FeedbackSignalInput): Promise<void> {
  await apiFetch("/crm/ai/feedback-signal", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function computeEditDistance(source: string, target: string): number {
  if (source === target) {
    return 0;
  }

  const sourceChars = Array.from(source);
  const targetChars = Array.from(target);
  const previous = Array.from({ length: targetChars.length + 1 }, (_, index) => index);
  const current = new Array<number>(targetChars.length + 1);

  for (let i = 1; i <= sourceChars.length; i++) {
    current[0] = i;
    const sourceChar = sourceChars[i - 1];
    if (sourceChar === undefined) {
      continue;
    }

    for (let j = 1; j <= targetChars.length; j++) {
      const targetChar = targetChars[j - 1];
      if (targetChar === undefined) {
        continue;
      }
      const substitutionCost = sourceChar === targetChar ? 0 : 1;
      const insertionCost = (current[j - 1] ?? Number.POSITIVE_INFINITY) + 1;
      const deletionCost = (previous[j] ?? Number.POSITIVE_INFINITY) + 1;
      const replacementCost = (previous[j - 1] ?? Number.POSITIVE_INFINITY) + substitutionCost;
      current[j] = Math.min(
        insertionCost,
        deletionCost,
        replacementCost,
      );
    }

    for (let j = 0; j <= targetChars.length; j++) {
      previous[j] = current[j]!;
    }
  }

  return previous[targetChars.length] ?? 0;
}
